



















import { Vue, Component } from 'vue-property-decorator';
import { getRules } from '../api';

@Component
export default class Rules extends Vue {
  tabs = [
    {
      id: 1,
      text: '活动意义',
    },
    {
      id: 2,
      text: '组织机构',
    },
    {
      id: 3,
      text: '奖项设置',
    },
    {
      id: 4,
      text: '参评要求',
    },
    {
      id: 5,
      text: '评选维度',
    },

    {
      id: 6,
      text: '评选流程',
    },
  ];
  activeIndex = 0;
  get rules() {
    return getRules(this.activeIndex + 1);
  }
  changeTab(index: number) {
    this.activeIndex = index;
  }
}
